var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vms-shell"},[_c('v-main',[_c('NavDrawer',{attrs:{"mini":_vm.mini},on:{"drawerToggled":function($event){_vm.mini = $event}}}),_c('AppBar',{attrs:{"drawer":_vm.drawer}}),_c('v-container',{staticClass:"vms-main-container",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }